var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group",
    { attrs: { id: "list-dnt" } },
    [
      _c("TraysFilters", {
        staticClass: "d-none",
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _vm._l(_vm.orderTrays, function(file) {
        return _c(
          "b-list-group-item",
          {
            key: file.aprobacionId,
            staticClass: "flex-column align-items-start bg-white mt-2",
            attrs: { file: file },
            on: {
              click: function($event) {
                return _vm.selectFile(file)
              }
            }
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-3 text-center text-primary" }, [
                _c("div", { staticClass: "d-flex justify-content-center" }, [
                  file.app === "FEB"
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Flujo de Febos",
                              expression: "'Flujo de Febos'"
                            }
                          ]
                        },
                        [
                          _c(
                            "vs-chip",
                            {
                              staticClass: "cursor-pointer mr-2",
                              class: { "text-success": _vm.wasCopied },
                              attrs: { color: "warning" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.copyToClipboard(
                                    file.id,
                                    file.numero
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(file.numero) + " ")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  file.app === "ED" && file.tipoObjetoId === "ARCHIVO-RP"
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Repositorio",
                              expression: "'Repositorio'"
                            }
                          ]
                        },
                        [
                          _c(
                            "vs-chip",
                            {
                              staticClass: "cursor-pointer mr-2",
                              class: { "text-success": _vm.wasCopied },
                              attrs: { color: "primary" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.copyToClipboard(
                                    file.id,
                                    file.numero
                                  )
                                }
                              }
                            },
                            [
                              _c("vs-avatar", {
                                attrs: { color: "primary", text: "R" }
                              }),
                              _vm._v(" " + _vm._s(file.numero) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  file.app === "ED" && file.tipoObjetoId === "EXP"
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Expediente",
                              expression: "'Expediente'"
                            }
                          ]
                        },
                        [
                          _c(
                            "vs-chip",
                            {
                              staticClass: "cursor-pointer mr-2",
                              class: { "text-success": _vm.wasCopied },
                              attrs: { color: "primary" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.copyToClipboard(
                                    file.id,
                                    file.numero
                                  )
                                }
                              }
                            },
                            [
                              _c("vs-avatar", {
                                attrs: { color: "primary", text: "E" }
                              }),
                              _vm._v(" " + _vm._s(file.numero) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  file.app === "ED" && file.tipoObjetoId === "ARCHIVO"
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Archivo",
                              expression: "'Archivo'"
                            }
                          ]
                        },
                        [
                          _c(
                            "vs-chip",
                            {
                              staticClass: "cursor-pointer mr-2",
                              class: { "text-success": _vm.wasCopied },
                              attrs: { color: "primary" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.copyToClipboard(
                                    file.id,
                                    file.numero
                                  )
                                }
                              }
                            },
                            [
                              _c("vs-avatar", {
                                attrs: { color: "primary", text: "A" }
                              }),
                              _vm._v(" " + _vm._s(file.numero) + " ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]),
              _c("div", { staticClass: "col-9" }, [
                _vm._v(" " + _vm._s(file.nombre) + " "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "" + file.descripcion,
                        expression: "`${file.descripcion}`"
                      }
                    ]
                  },
                  [
                    _c("small", { staticClass: "text-primary" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("truncate")(file.descripcion, 40)) +
                          " "
                      )
                    ])
                  ]
                )
              ]),
              _c("div", { staticClass: "col-6" }, [
                _vm._v(" " + _vm._s(file.autor) + " ")
              ]),
              _c(
                "div",
                { staticClass: "col-6" },
                [
                  file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.INITIATED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Iniciado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "query_builder", color: "#43C3B9" }
                          }),
                          _vm._v(" Iniciado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.PREPARED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Pendiente" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "language", color: "#adadad" }
                          }),
                          _vm._v(" Preparado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.APPROVED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Aprobado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "thumb_up", color: "#28c76f" }
                          }),
                          _vm._v(" Aprobado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.REJECTED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Rechazado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "thumb_down", color: "#ea5455" }
                          }),
                          _vm._v(" Rechazado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.CANCELED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Retornado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "block", color: "#bf0303" }
                          }),
                          _vm._v(" Anulado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.aprobacionesEjecucionEstadoId.toString() ===
                  _vm.FileStates.DISMISSED
                    ? _c(
                        "vs-chip",
                        { attrs: { title: "Desestimado" } },
                        [
                          _c("vs-avatar", {
                            attrs: { icon: "save_alt", color: "#848484" }
                          }),
                          _vm._v(" Desestimado ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 pt-2 border-top" },
                [
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Fecha inicio del proceso",
                          expression: "'Fecha inicio del proceso'"
                        }
                      ],
                      staticClass: "mr-4"
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "date_range" } }),
                      _vm._v(
                        " inicio " +
                          _vm._s(
                            _vm._f("dateFormat")(file.fechaInicioProceso)
                          ) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Proceso de pasos",
                          expression: "'Proceso de pasos'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "primary", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "group" } }),
                      _vm._v(
                        " paso " +
                          _vm._s(file.numeroPaso) +
                          " de " +
                          _vm._s(file.totalPasos) +
                          " "
                      )
                    ],
                    1
                  ),
                  _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Nombre de documento en flujo",
                          expression: "'Nombre de documento en flujo'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "warning", transparent: "" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "description" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("truncate")(file.objetoNombre, 20)) +
                          " "
                      )
                    ],
                    1
                  ),
                  file.privado === "Y"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Privado",
                              expression: "'Privado'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "primary", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "lock" } }),
                          _vm._v(" privado ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.folio
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Número de documento",
                              expression: "'Número de documento'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "description" } }),
                          _vm._v(" " + _vm._s(file.folio) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.foliado
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Fecha de documento",
                              expression: "'Fecha de documento'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "date_range" } }),
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("dateFormat")(file.foliado)) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  file.tipoObjetoCategoria
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tipo de documento",
                              expression: "'Tipo de documento'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "description" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("truncate")(file.tipoObjetoCategoria, 20)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  file.oficinaNombre
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Oficina que numeró o tramitó",
                              expression: "'Oficina que numeró o tramitó'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "apartment" } }),
                          _vm._v(" " + _vm._s(file.oficinaNombre) + " ")
                        ],
                        1
                      )
                    : _vm._e(),
                  file.app === "FEB"
                    ? _c(
                        "vs-chip",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: "Tipo de documento en flujo",
                              expression: "'Tipo de documento en flujo'"
                            }
                          ],
                          staticClass: "mr-4",
                          attrs: { color: "warning", transparent: "" }
                        },
                        [
                          _c("vs-avatar", { attrs: { icon: "description" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.findTypeDocument(file.tipoReferencia)
                              ) +
                              " "
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        )
      }),
      _c("FilesPagination", {
        attrs: { show: _vm.trays.length },
        model: {
          value: _vm.page,
          callback: function($$v) {
            _vm.page = $$v
          },
          expression: "page"
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }